// src/pdf-icon.tsx
import { createSvgIcon } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var PDFIcon = createSvgIcon(
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19.788 7.2a.736.736 0 0 1 .212.505v.713h-5.79a.729.729 0 0 1-.512-.21.707.707 0 0 1-.212-.503V3.426H5.525v5.068H4.077V3.426c0-.38.155-.741.425-1.008.27-.266.637-.418 1.023-.418h8.685a.75.75 0 0 1 .511.21l5.067 4.99Zm-4.854-2.766v2.558h2.596l-2.596-2.558Zm-8.03 5.372H4v8.782h1.38v-3.437c0-.242.222-.43.502-.43h1.032c1.043 0 1.882-.743 1.882-1.656v-1.602c0-.914-.85-1.657-1.882-1.657h-.01Zm.503 3.259c0 .242-.222.43-.502.43H5.872c-.164 0-.328.018-.492.053v-2.524h1.525c.28 0 .502.197.502.43v1.611Zm12.545-2.032V9.806h-4.188v8.783h1.38V14.72h1.62v-1.217h-1.62v-2.471h2.808ZM9.645 9.806h2.905c1.033 0 1.882.743 1.882 1.657v5.425c0 .922-.859 1.7-1.882 1.7H9.645V9.806Zm3.407 7.082v-5.434c0-.233-.222-.43-.502-.43h-1.525v6.338h1.525c.27 0 .502-.224.502-.474Zm-8.975 2.676v.01-.01Zm0 .01H20c0 .38-.154.741-.425 1.008-.27.266-.636.418-1.023.418H5.525a1.436 1.436 0 0 1-1.448-1.426Z",
      clipRule: "evenodd"
    }
  ),
  "PDFIcon"
);

export {
  PDFIcon
};
